import { format as formatUrl, parse as parseUrl } from 'url';

const initialState = {
  loading: false,
  invoices: [],
};

const formatDownloadUrl = (url, ssoOrgId) => {
  if (!url || !ssoOrgId) return url;

  const parsed = parseUrl(url, true);

  // set the magic query param
  parsed.query.current_company = ssoOrgId;

  // `search` trumps `query`
  delete parsed.search;

  return formatUrl(parsed);
};

const invoicesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'GET_INVOICES_REQUEST': {
      return {
        ...state,
        loading: true,
      };
    }

    case 'GET_INVOICES_SUCCESS': {
      const { ssoOrgId } = action.extra;

      return {
        invoices: action.payload.map((invoice) => ({
          id: invoice.id,
          reference: invoice.reference,
          startDate: invoice.start_date,
          endDate: invoice.end_date,
          net: invoice.total.formatted,
          downloadLinks: {
            csv: formatDownloadUrl(invoice.download_links.csv, ssoOrgId),
            pdf: formatDownloadUrl(invoice.download_links.pdf, ssoOrgId),
            invoice_pdf: formatDownloadUrl(
              invoice.download_links.invoice_pdf,
              ssoOrgId,
            ),
            statement_csv: formatDownloadUrl(
              invoice.download_links.statement_csv,
              ssoOrgId,
            ),
            statement_pdf: formatDownloadUrl(
              invoice.download_links.statement_pdf,
              ssoOrgId,
            ),
          },
        })),

        loading: false,
        error: undefined,
      };
    }

    case 'GET_INVOICES_FAILURE': {
      return {
        invoices: [],
        loading: false,
        error: action.status,
      };
    }

    default:
      return state;
  }
};

export default invoicesReducer;
